import * as Types from "src/state/_types"
import * as GQL from "src/state/gql/_types"

export const OperationsAdminVenueTalentViewSchema: Types.ViewSchemaType<GQL.UserFragment> = {
    enums: [],
    fields: [
        {
            label: "Email",
            field: "email",
            type: "text"
        },
        {
            label: "User Number",
            field: "user_number",
            type: "number"
        },
        {
            label: "First Name",
            field: "first_name",
            type: "text"
        },
        {
            label: "Last Name",
            field: "last_name",
            type: "text"
        },
        {
            label: "Alias",
            field: "alias",
            type: "text"
        },
        {
            label: "Address Line1",
            field: "address_line1",
            type: "text"
        },
        {
            label: "Address Line2",
            field: "address_line2",
            type: "text"
        },
        {
            label: "City",
            field: "city",
            type: "text"
        },
        {
            label: "State",
            field: "state",
            type: "text"
        },
        {
            label: "Country",
            field: "country",
            type: "text"
        },
        {
            label: "Postal Code",
            field: "postal_code",
            type: "text"
        },
        {
            label: "Phone",
            field: "phone",
            type: "text"
        },
        {
            label: "Bday",
            field: "bday",
            type: "date"
        },
        {
            label: "Website",
            field: "website",
            type: "text"
        },
        {
            label: "Instagram",
            field: "instagram",
            type: "text"
        },
        {
            label: "Facebook",
            field: "facebook",
            type: "text"
        },
        {
            label: "X",
            field: "x",
            type: "text"
        },
        {
            label: "Tiktok",
            field: "tiktok",
            type: "text"
        },
        {
            label: "Deleted",
            field: "deleted",
            type: "boolean"
        },
        {
            label: "Genres Played",
            field: "genres",
            type: "multi-select" 
        },
        {
            label: "Created At",
            field: "created_at",
            type: "datetime"
        },
        {
            label: "Updated At",
            field: "updated_at",
            type: "datetime"
        }
    ],
    relations: {
        tenant: {
            relation: "tenant",
            label: "Tenant",
            fields: [
                {
                    label: "Id",
                    field: "id",
                    type: "text"
                },
                {
                    label: "Name",
                    field: "name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                }
            ]
        },
        created_by_user: {
            relation: "created_by_user",
            label: "Created By User",
            fields: [
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "First Name",
                    field: "first_name",
                    type: "text"
                },
                {
                    label: "Last Name",
                    field: "last_name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Role",
                    field: "role",
                    type: "text"
                }
            ]
        },
        updated_by_user: {
            relation: "updated_by_user",
            label: "Updated By User",
            fields: [
                {
                    label: "Email",
                    field: "email",
                    type: "text"
                },
                {
                    label: "First Name",
                    field: "first_name",
                    type: "text"
                },
                {
                    label: "Type",
                    field: "type",
                    type: "text"
                },
                {
                    label: "Role",
                    field: "role",
                    type: "text"
                }
            ]
        }
    }
}